import axios from 'axios';
import store from '../store';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  equipes: [],
  equipeColaboradores: []
};

const getters = {
  // Equipe
  equipes: state => state.equipes.sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  equipesAtivo: state => state.equipes.filter(e => e.Status.startsWith('A')).sort((a,b) => a.Descricao > b.Descricao ? 1 : -1),
  equipeColaboradores: state => state.equipeColaboradores.sort((a,b) => a.Colaborador > b.Colaborador ? 1 : -1),
}

const actions = {
  // Reset State
  resetStateEquipe({ commit }) {
    commit('resetStateEquipe');
  },
  // Equipe
  async fetchEquipes({ commit }) {
    const response = await axios.get(`${baseUrl}/equipes`);
    if (response.data) {
      commit('setEquipes', response.data);
    } else {
      commit('setEquipes', []);
    }
  },
  async fetchEquipesSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/equipes?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setEquipes', response.data);
      } else {
        commit('setEquipes', []);
      }
    } catch (error) {
      commit('setEquipes', []);
    }
  },
  async addEquipe({ commit }, equipe) {
    const response = await axios.post(`${baseUrl}/equipes`, equipe);
    equipe.IdEquipe = response.data.IdEquipe;
    commit('newEquipe', equipe);
    return response.data.IdEquipe;
  },
  async updateEquipe({ commit }, updEquipe) {
    await axios.put(`${baseUrl}/equipes`, updEquipe);
    commit('updateEquipe', updEquipe);
  },
  async deleteEquipe({ commit }, id) {
    await axios.delete(`${baseUrl}/equipes/${id}`);
    commit('removeEquipe', id);
  },

  // Colaborador
  async fetchEquipeColaboradores({ commit }, id) {
    const response = await axios.get(`${baseUrl}/equipes/${id}/colaboradores`);
    if (response.data.length) {
      commit('setEquipeColaboradores', response.data);
      return response.data;
    } else {
      commit('setEquipeColaboradores', []);
      return false;
    }
  },
  async addEquipeColaborador({ commit }, colaborador) {
    try {
      const response = await axios.post(`${baseUrl}/equipes/${colaborador.IdEquipe}/colaboradores`, colaborador);
      if (response) {
        commit('newEquipeColaborador', colaborador);
      }
      return response;
    } catch (error) {
      console.log(error);
      return error;
    }
  },
  async deleteEquipeColaborador({ commit }, colaborador) {
    await axios.delete(`${baseUrl}/equipes/${colaborador.IdEquipe}/colaboradores/${colaborador.IdColaborador}`);
    commit('removeEquipeColaborador', colaborador.IdColaborador);
  },
}

const mutations = {
  // Reset State
  resetStateEquipe: state => state.equipeColaboradores = [],
  // Equipe
  setEquipes: (state, equipes) => state.equipes = equipes,
  newEquipe: (state, equipe) => state.equipes.push(equipe),
  removeEquipe: (state, id) => state.equipes = state.equipes.filter(equipe => equipe.IdEquipe !== id),
  updateEquipe: (state, updEquipe) => {
    const index = state.equipes.findIndex(equipe => equipe.IdEquipe === updEquipe.IdEquipe);
    if (index !== -1) {
      state.equipes.splice(index, 1, updEquipe);
    }
  },
  // Colaborador
  setEquipeColaboradores: (state, colaboradores) => state.equipeColaboradores = colaboradores,
  newEquipeColaborador: (state, colaborador) => state.equipeColaboradores.push(colaborador),
  removeEquipeColaborador: (state, id) => state.equipeColaboradores = state.equipeColaboradores.filter(colaborador => colaborador.IdColaborador !== id),
}

export default {
  state,
  getters,
  actions,
  mutations
}